<template>
  <div class="col-12">
    <div class=" row text-center m-5">
      <h3 class="ui inverted purple text"><strong> Complete</strong></h3>
    </div>
    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-11 col-lg-9">
        <div class="ui violet floating message m-4">
          <div class="header mb-2">
            TN CyberTech Bank
          </div>
          <p>In approximately 10 seconds you will be asked to enter your EcoCash PIN  on your mobile phone to facilitate the account opening fee. This will enable us to co that we can accept your account opening request.</p>
        </div>
        <button class="ui button  grey fluid mt-4 mb-4" @click="login()">Logout</button>
      </div>
    </div>
  </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { http } from "@/utils/http";
import { utils } from "@/utils/utils";
export default {
  name: 'T24Complete',
  data() {
    return {
      customer: {
        mobileNumber: localStorage.getItem("phone-number"),
        title: localStorage.getItem("title"),
        firstName: localStorage.getItem("first-name"),
        lastName: localStorage.getItem("last-name"),
        idNumber: localStorage.getItem("identity-doc-no"),
        gender: localStorage.getItem("gender"),
        street: localStorage.getItem("street"),
        town: localStorage.getItem("town"),
        currency: localStorage.getItem("currency-type"),
        dateOfBirth: localStorage.getItem("dateOfBirth"),
        //  gotCustomerData: false,
        requestType: "PRE_PROCESS_CURRENT_ACCOUNT",
      },
      addendum:
      {
        firstName: localStorage.getItem("first-name"),
        lastName: localStorage.getItem("last-name"),
        idNumber: localStorage.getItem("identity-doc-no"),
        street: localStorage.getItem("street"),
        town: localStorage.getItem("town"),
        lineOfBusiness: localStorage.getItem("lineOfBusiness"),
        sourceOfIncome: localStorage.getItem("sourceOfIncome"),
        monthlyIncomeAmount: localStorage.getItem("monthlyIncomeAmount"),
        activityExpectedOnAccount: localStorage.getItem("activityExpectedOnAccount"),
        signature: localStorage.getItem("signature"),
        customerUid: localStorage.getItem("uid")

      },
    };
  },
  mounted() {

  this.uploadFiles();

  },
  methods: {
    login() {
      this.$router.push("/account-opening/login");
    },
    paymentMethod() {
      this.postNoAuthAndNoBaseUrl(
        URLS.processAccount,
        this.customer,
        "Customer Data Uploaded",
        null,
        true
      ).then((res) => {
        if (!res) return;
        if (res.errors) return (this.errors = res.errors);
        if (res.body.status === "COMPLETE") {
          this.uploadFiles();
        }});
    },

    uploadFiles() {

        this.model = JSON.parse(localStorage.getItem('model'));


        console.log(this.model);

       if (this.model.files.length === 0) {
          
            console.log("there are no files here!");
          }


      this.model.files.forEach((file) => {
        let formData = new FormData();
        formData.append("phone", localStorage.getItem("phone-number"));
        formData.append("customerUid", localStorage.getItem("uid"));
        formData.append("documentTypeLabel", file.docType);
        formData.append("citizenId", localStorage.getItem("identity-doc-no"));

        formData.append("files", file.file);

        this.addOp();

        console.log("uploading docs");
        console.log(formData);

        http
          .postFormDataNoAuth(URLS.documents + "/upload", formData)
          .then((res) => {
            utils.logger("upload result", res);
            this.removeOp();
            return this.handleGetResponse(res, true);
          })
          .then((res) => {
            if (!res) return;
            if (res.errors) return (this.errors = res.errors);




          });

      });
    }
  ,
  ...baseMethods,
  },
};
</script>
